import * as yup from "yup";

export const schema = yup.object().shape({
  make: yup.string().required("Please choose a make"),
  model: yup.string().required("Please choose a model"),
  fuelType: yup.string().required("Please choose a fuel type"),
  yearOfRegistration: yup
    .string()
    .required("Please choose the year of registration"),
  colour: yup.string().required("Please choose a colour"),
  metallicPaint: yup
    .string()
    .required("Please choose an option for metallic paint"),
  chooseYourCar: yup.string().required("Please choose your car"),
  previousOwners: yup
    .string()
    .required("Please choose how many previous owners")
});
